import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SocialSignInButtons.module.scss";
import googleGLogo from "./google-g-logo.svg";
import appleLogo from "./apple-logo.svg";

export interface ISocialSignInButtonsProps {
  onGoogle: () => void;
  onApple: () => void;
  isLoading?: boolean;
  error?: string | null;
}

export const SocialSignInButtons: VoidFunctionComponent<ISocialSignInButtonsProps> = ({
  onGoogle,
  onApple,
  isLoading = false,
  error = null,
}) => {
  return (
    <div className={s.container}>
      <button
        type="button"
        className={`${s.button} ${s.apple}`}
        onClick={onApple}
        disabled={isLoading}
        aria-busy={isLoading}
        aria-label="Sign in with Apple"
      >
        <span className={s.content}>
          <img className={s.appleLogo} src={appleLogo} alt="" />
          <span className={s.label}>Sign in with Apple</span>
        </span>
      </button>
      <button
        type="button"
        className={`${s.button} ${s.google}`}
        onClick={onGoogle}
        disabled={isLoading}
        aria-busy={isLoading}
        aria-label="Sign in with Google"
      >
        <span className={s.googleState} aria-hidden="true" />
        <span className={s.content}>
          <img className={s.googleLogo} src={googleGLogo} alt="" />
          <span className={s.label}>Sign in with Google</span>
        </span>
      </button>
      {error !== null && error.length > 0 ? (
        <p className={s.error} role="alert">{error}</p>
      ) : null}
    </div>
  );
};
